module.exports = __webpack_public_path__ + "5877a49cfbb65c03ecbbd07e4cfcd2ef.png";